import React from 'react';

import { RecommendedProducts as Products } from 'src/explore/compositions/RecommendedProducts';

interface Props {
  clickRef?: string;
  hideLove?: boolean;
  hideMerchant?: boolean;
  pageType?: string;
}

const RecommendedProducts: React.FC<Props> = ({ clickRef, hideLove, hideMerchant, pageType }) => (
  <Products
    clickRef={clickRef}
    hideLove={hideLove}
    hideMerchant={hideMerchant}
    pageType={pageType}
  />
);

export default RecommendedProducts;
